const CMSProceduresServices = (instance) => {

    const getProceduresData = () => instance.get('procedures');

    return {
        getProceduresData,
    };
};
export default CMSProceduresServices;